import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { PageLayoutModule } from '../page-layout';
import { InviteLink } from './models';
import { InviteLinkService } from './invite-link.service';

@Component({
    standalone: true,
    selector: 'abs-invite-redeem',
    imports: [CommonModule, IonicModule, TranslateModule, PageLayoutModule],
    template: `
        <abs-page-layout [pageTitle]="invite()?.title || ('GLOBAL.INVITE.TITLE' | translate)">
            @if (loading()) {
                <ion-spinner name="crescent"></ion-spinner>
            } @else if (notFound()) {
                <ion-card color="danger">
                    <ion-card-content>{{ 'GLOBAL.INVITE.NOT_FOUND' | translate }}</ion-card-content>
                </ion-card>
            } @else if (redeemed()) {
                <ion-card color="success">
                    <ion-card-content>{{ 'GLOBAL.INVITE.REDEEMED' | translate }}</ion-card-content>
                </ion-card>
                <ion-button expand="block" (click)="continueAfterAccept()">{{ 'GLOBAL.INVITE.CONTINUE' | translate }}</ion-button>
            } @else if (invite(); as invite) {
                <ion-card>
                    <ion-card-content [innerHTML]="invite.description || ('GLOBAL.INVITE.GENERIC_PROMPT' | translate)">
                    </ion-card-content>
                </ion-card>
                <ion-button expand="block" [disabled]="accepting()" (click)="accept(invite)">
                    {{ 'GLOBAL.INVITE.ACCEPT' | translate }}
                </ion-button>
            }
        </abs-page-layout>
    `
})
export class InviteRedeemPage implements OnInit {
    private service = inject(InviteLinkService);
    private route = inject(ActivatedRoute);

    loading = signal(true);
    notFound = signal(false);
    redeemed = signal(false);
    accepting = signal(false);
    invite = signal<InviteLink | null>(null);

    ngOnInit() {
        const code = this.route.snapshot.paramMap.get('code')!;
        this.service.getByCode(code).subscribe({
            next: (invite) => {
                this.invite.set(invite);
                this.loading.set(false);
            },
            error: () => {
                this.notFound.set(true);
                this.loading.set(false);
            }
        });
    }

    accept(invite: InviteLink) {
        this.accepting.set(true);
        this.service.redeem(invite.code).subscribe({
            next: () => {
                this.accepting.set(false);
                this.redeemed.set(true);
            },
            error: () => {
                this.accepting.set(false);
                this.notFound.set(true);
            }
        });
    }

    // A full page navigation (not an Angular route) so the freshly granted role/feature access
    // is picked up on reload, rather than reusing whatever roles/flags were cached at page load.
    continueAfterAccept() {
        window.location.href = this.invite()?.redirectUrl || '/';
    }
}
